import React from 'react'

export default function Footer(){
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div>© {new Date().getFullYear()} Bechir Dridi — Full Stack & GenAI Developer.</div>
        <div className="footer-links">
          <a href="https://github.com/Bechir-Dridi" target="_blank" rel="noreferrer">GitHub</a>
          <a href="https://www.linkedin.com/in/bechir-dev/" target="_blank" rel="noreferrer">LinkedIn</a>
          <a href="https://twitter.com/bechir7dridi" target="_blank" rel="noreferrer">Twitter</a>
          <a href="mailto:b7dridi@gmail.com">Email</a>
          <a href="https://bechirdev.vercel.app" target="_blank" rel="noreferrer">bechirdev.vercel.app</a>
        </div>
      </div>
    </footer>
  )
}
